import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=191d3c04&scoped=true"
import script from "./BookInfo.vue?vue&type=script&lang=js"
export * from "./BookInfo.vue?vue&type=script&lang=js"
import style0 from "./BookInfo.vue?vue&type=style&index=0&id=191d3c04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d3c04",
  null
  
)

export default component.exports